@if (operation) {
  <div class="canvas-pointage">
    <div class="canvas-pointage__overlay" (click)="!enregistrement && annuler.emit()"></div>
    <div class="canvas-pointage__panel" role="dialog" aria-modal="true" aria-labelledby="titre-pointage">
      <h3 id="titre-pointage">
        {{ historiqueUniquement ? 'Opérations de' : operation.provision ? 'Utiliser' : 'Pointer' }} {{ operation.libelle }}
      </h3>
      @if (libellePeriode) {
        <p class="canvas-pointage__info">{{ libellePeriode }}</p>
      }
      @if (!historiqueUniquement) {
        <p class="canvas-pointage__info">
          Montant proposé : <strong>{{ formatterMontant(montantInitial) }}</strong>
        </p>
      }
      @if (erreur) {
        <p class="alerte alerte--erreur" role="alert">{{ erreur }}</p>
      }
      @if (operation.provision) {
        <section class="historique-provision provision-en-attente">
          <div class="provision-en-attente__entete">
            <h4>À pointer</h4>
            @if (!ajoutNonPointe) {
              <button type="button" class="btn-secondaire btn-ajouter-provision"
              [disabled]="enregistrement" (click)="ouvrirAjoutNonPointe()">Ajouter une opération non pointée</button>
            }
          </div>
          @if (!operationsNonPointees.length) {
            <p>Aucune opération en attente.</p>
          }
          @if (operationsNonPointees.length) {
            <div class="historique-provision__scroll">
              <table>
                <thead><tr><th>Libellé</th><th>Date</th><th>Montant</th><th>Actions</th></tr></thead>
                <tbody>
                  @for (h of operationsNonPointees; track h) {
                    <tr>
                      <td>{{ h.libelle }}@if (h.moyenPaiement === 'CHEQUE' && h.numeroCheque) {
                        <span class="cheque-numero"> (C{{ h.numeroCheque }})</span>
                      }</td>
                      <td>{{ h.dateOperation | date: 'dd/MM/yyyy' }}</td>
                      <td>{{ formatterMontant(h.montant) }}</td>
                      <td>
                        <div class="provision-en-attente__actions">
                          @if (editionAutorisee) {
                            <button type="button" class="btn-action-provision btn-editer-operation"
                              [disabled]="enregistrement" title="Modifier cette opération"
                              [attr.aria-label]="'Modifier ' + h.libelle" (click)="editerOperation.emit(h.id)">
                              <i class="ph-fill ph-pencil-simple" aria-hidden="true"></i>
                            </button>
                          }
                          <button type="button" class="btn-action-provision btn-pointer-provision" [disabled]="enregistrement"
                            title="Pointer" [attr.aria-label]="'Pointer ' + h.libelle" (click)="pointerOperation.emit(h.id)">
                            <i class="ph-fill ph-check" aria-hidden="true"></i>
                          </button>
                          <button type="button" class="btn-action-provision btn-reporter-provision" [disabled]="enregistrement"
                            title="Reporter au mois suivant" [attr.aria-label]="'Reporter ' + h.libelle + ' au mois suivant'" (click)="reporterOperation.emit(h.id)">
                            <i class="ph-fill ph-calendar-plus" aria-hidden="true"></i>
                          </button>
                          <button type="button" class="btn-action-provision btn-supprimer-provision" [disabled]="enregistrement"
                            title="Supprimer" [attr.aria-label]="'Supprimer ' + h.libelle" (click)="supprimerOperation.emit(h.id)">
                            <i class="ph-fill ph-trash" aria-hidden="true"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }
          @if (operationsNonPointees.length) {
            <div class="historique-provision__total">
              <span>Total à pointer</span><strong>{{ formatterMontant(totalNonPointe) }}</strong>
            </div>
          }
        </section>
      }
      @if (operationsReelles.length) {
        <div class="historique-provision"
          >
          <h4>{{ libellePeriode ? 'Pointé en ' + libellePeriode : 'Déjà pointé ce mois-ci' }}</h4>
          <div class="historique-provision__scroll">
            <table>
              <thead>
                <tr>
                  <th>Libellé</th>
                  <th>Date</th>
                  <th>Montant</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                @for (h of operationsReelles; track h) {
                  <tr>
                    <td>
                      {{ h.libelle }}
                      @if (h.moyenPaiement === 'CHEQUE' && h.numeroCheque) {
                        <span class="cheque-numero">(C{{ h.numeroCheque }})</span>
                      }
                    </td>
                    <td>{{ h.dateOperation | date: 'dd/MM/yyyy' }}</td>
                    <td>{{ formatterMontant(h.montant) }}</td>
                    <td>
                      @if (editionAutorisee) {
                        <button type="button" class="btn-action-provision btn-editer-operation"
                          [disabled]="enregistrement" title="Modifier cette opération"
                          [attr.aria-label]="'Modifier ' + h.libelle" (click)="editerOperation.emit(h.id)">
                          <i class="ph-fill ph-pencil-simple" aria-hidden="true"></i>
                        </button>
                      }
                      <button type="button" class="btn-depointer" [disabled]="enregistrement" title="Dépointer cette opération" (click)="depointerOperation.emit(h.id)">
                        <i class="ph-fill ph-arrow-counter-clockwise" aria-hidden="true"></i>
                      </button>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
          <div class="historique-provision__total">
            <span>Total</span>
            <strong>{{ formatterMontant(totalReelles) }}</strong>
          </div>
        </div>
      }
      @if (historiqueUniquement) {
        <button type="button" class="btn-secondaire" (click)="annuler.emit()">Fermer</button>
      }
      @if (!historiqueUniquement) {
        <form [formGroup]="form" (ngSubmit)="submit()" class="formulaire">
          <fieldset class="pointage-champs" [disabled]="enregistrement">
            @if (ajoutNonPointe) {
              <h4>Nouvelle opération non pointée</h4>
              <label>Libellé<input type="text" formControlName="libelle" /></label>
            }
            <label>
              {{ operation.provision && !ajoutNonPointe ? 'Montant à utiliser' : 'Montant' }}
              <input #montantInput type="text" appMontant formControlName="montant" autofocus />
            </label>
            @if (ajoutNonPointe) {
              <label>Date de l'opération<input type="date" formControlName="dateOperation" /></label>
            }
            <label>
              Moyen de paiement
              <select formControlName="moyenPaiement">
                <option [ngValue]="null">Aucun</option>
                @for (m of moyensPaiement; track m) {
                  <option [ngValue]="m.value">{{ m.label }}</option>
                }
              </select>
            </label>
            @if (form.get('moyenPaiement')?.value === 'CHEQUE') {
              <label>
                Numéro de chèque
                <input type="text" formControlName="numeroCheque" />
              </label>
            }
            @if (form.get('moyenPaiement')?.value === 'VIREMENT') {
              <label>
                Compte destination
                <select formControlName="compteDestinationId">
                  <option [ngValue]="null">Sélectionner un compte</option>
                  @for (c of comptesDisponibles; track c) {
                    <option [ngValue]="c.id">{{ c.nom }}</option>
                  }
                </select>
              </label>
            }
            <div class="form-actions">
              <button type="submit" [disabled]="form.invalid">
                {{ ajoutNonPointe ? 'Ajouter sans pointer' : operation.provision ? 'Utiliser' : 'Pointer' }}
              </button>
              @if (operation.provision && !ajoutNonPointe) {
                <button type="button" class="btn-secondaire"
                  [disabled]="form.invalid"
                  (click)="submit(true)">
                  Utiliser et continuer
                </button>
              }
              @if (ajoutNonPointe) {
                <button type="button" class="btn-secondaire" (click)="annulerAjoutNonPointe()">Annuler l'ajout</button>
              }
              @if (!ajoutNonPointe) {
                <button type="button" class="btn-secondaire" (click)="!enregistrement && annuler.emit()">
                  Fermer
                </button>
              }
            </div>
          </fieldset>
        </form>
      }
    </div>
  </div>
}
